export const loadAuditLogView = () => import("./views/audit-log.view");
